export default "__VITE_ASSET__BXG6b3nJ__"